<template>
  <section id="cards">
    <div class="demo">
      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="card h-100">
          </div> 
        </div> 
        <div class="col-md-6 mb-3">
          <div class="card">
            <h3 class="card-title">Card title</h3>
            <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
          </div>
        </div>   
        <div class="col-md-6 col-xxl-4">
          <div class="card text-center">
            <img class="illustrations" src="@/assets/gel/images/illustrations/job.svg" alt="Jobs panel">
            <div class="card-body text-16">
              <h4 class="mb-4">Jobs</h4>
              <p class="card-text"><a class="link-alt" href="jobs"><span class="text-20 text-blue">11</span> Jobs</a></p>
              <p class="card-text"><a class="link-alt" href="jobs"><span class="text-20 text-blue">25</span> Team jobs open</a></p>
              <p class="mt-4"><button title="Create a job" type="button" class="btn btn-primary">Create</button></p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xxl-4 mb-3">
          <div class="card">
            <h3><a href="#">Senior Project Manager</a></h3>
            <dl class="mt-2 mb-n-3">
              <dt>Requisition number:</dt><dd>5417283</dd>
              <dt>Type:</dt><dd>Requisition</dd>
              <dt>Position:</dt><dd >2</dd>
              <dt>Status:</dt><dd><a href="#">Approval of Appointment</a></dd>
              <dt>Hiring Manager:</dt><dd><a href="#">Arnold Schwarzenegger</a></dd>
              <dt>Recruitment Workflow:</dt><dd>Regular Recruitment</dd>
            </dl>
          </div>
        </div>
        <div class="col-md-6 col-xxl-4">
          <div class="card">
            <div class="d-flex">
              <img class="avatar avatar-md" src="@/assets/gel/site-images/avatar.svg">
              <span class="ml-3 d-flex flex-column justify-content-center">
                <h4 class="mb-0">Peter Parker</h4>
                <span class="text-muted">Senior Project Manager</span>
              </span>
            </div>
            <hr class="d-block">
            <dl class="mb-0">
              <dt class="text-14">Phone</dt><dd>+61 4123 111 111</dd>
              <dt class="text-14">Address</dt><dd>91 William Street, Melbourne, VIC, Australia</dd>
              <dt class="text-14">Email</dt><dd><a href="mailto:peters+daniels@pageuppeople.com">peter.parker@company.com</a></dd>
              <dt class="text-14">Employment status</dt><dd>Never employed or contracted</dd>
            </dl>
            <div class="text-right">
              <button class="btn btn-outline-primary">View Profile</button>
            </div>
          </div>
        </div>
      </div>    
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>  
  
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4';
import mdfile from "@/docs/components/cards.md";
export default {
  name: "cards",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.cards.name);
    this.$emit("update-tagline", this.$root.yamlData.components.cards.description);
  },
  mounted: function () {
    const dropdowns = document.querySelectorAll('[data-toggle="dropdown"]')
    dropdowns.forEach(dropdown => {
      new BSN.Dropdown(dropdown)
    })
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
